import { render, staticRenderFns } from "./SalesmanUpdate.vue?vue&type=template&id=1b929e5b&"
import script from "./SalesmanUpdate.vue?vue&type=script&lang=js&"
export * from "./SalesmanUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports